var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCombo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 3.33333C0.666504 1.49238 2.15889 0 3.99984 0H13.9998C15.8408 0 17.3332 1.49238 17.3332 3.33333V4.58333H13.9998C12.389 4.58333 11.0832 5.88917 11.0832 7.5C11.0832 9.11083 12.389 10.4167 13.9998 10.4167H17.3332V11.6667C17.3332 13.5076 15.8408 15 13.9998 15H3.99984C2.15889 15 0.666504 13.5076 0.666504 11.6667V3.33333ZM13.9998 9.16667H17.3332V5.83333H13.9998C13.0794 5.83333 12.3332 6.57953 12.3332 7.5C12.3332 8.42048 13.0794 9.16667 13.9998 9.16667Z",
    fill: "#D3B418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombo);
export default __webpack_public_path__ + "static/media/Combo.3282768e.svg";
export { ForwardRef as ReactComponent };